class RequestDelayer {
	constructor(callback, duration) {
		this.duration = duration
		this.callback = callback
	}

	clearAndAbort = () => {
		clearTimeout(this.timeout)

		if (this.request) {
			this.request.abort()
		}
	}

	call = (...params) => {
		this.clearAndAbort()
		this.request = this.callback(...params)
	}

	delay = (...params) => {
		this.clearAndAbort()

		this.timeout = window.setTimeout(() => {
			this.call(...params)
		}, this.duration)
	}
}

export default RequestDelayer
